var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.978271,
    y: 1,
    width: 35,
    height: 35,
    rx: 7.5,
    fill: "#F0F0F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4783 9.5C26.0087 9.5 26.5174 9.71071 26.8925 10.0858C27.2676 10.4609 27.4783 10.9696 27.4783 11.5V25.5C27.4783 26.0304 27.2676 26.5391 26.8925 26.9142C26.5174 27.2893 26.0087 27.5 25.4783 27.5H11.4783C10.9478 27.5 10.4391 27.2893 10.0641 26.9142C9.68899 26.5391 9.47827 26.0304 9.47827 25.5V11.5C9.47827 10.9696 9.68899 10.4609 10.0641 10.0858C10.4391 9.71071 10.9478 9.5 11.4783 9.5H25.4783ZM24.9783 25V19.7C24.9783 18.8354 24.6348 18.0062 24.0234 17.3948C23.4121 16.7835 22.5829 16.44 21.7183 16.44C20.8683 16.44 19.8783 16.96 19.3983 17.74V16.63H16.6083V25H19.3983V20.07C19.3983 19.3 20.0183 18.67 20.7883 18.67C21.1596 18.67 21.5157 18.8175 21.7782 19.0801C22.0408 19.3426 22.1883 19.6987 22.1883 20.07V25H24.9783ZM13.3583 15.06C13.8038 15.06 14.2312 14.883 14.5462 14.5679C14.8613 14.2529 15.0383 13.8256 15.0383 13.38C15.0383 12.45 14.2883 11.69 13.3583 11.69C12.9101 11.69 12.4802 11.8681 12.1633 12.185C11.8463 12.5019 11.6683 12.9318 11.6683 13.38C11.6683 14.31 12.4283 15.06 13.3583 15.06ZM14.7483 25V16.63H11.9783V25H14.7483Z",
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.978271,
    y: 1,
    width: 35,
    height: 35,
    rx: 7.5,
    stroke: "#ECECEC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.e38ccf5bd4a64167e12e93312dd07cf8.svg";
export { ForwardRef as ReactComponent };